import React from 'react'
import { intl } from 'lang/intl'

import { TtIcon, TtTooltip } from '@23/ui-react'

import { useWebinarColors } from '../../Designs/blocs/useWebinarColors'
import usePollsOverlays, {
  toPollOverlayPayload,
} from '../../Webinar/hooks/usePollsOverlay'
import type { Poll } from '../model/Poll'

import './PollOverlayTrigger.scss'

type PollOverlayTriggerProps = {
  poll: Poll
}

export const PollOverlayTrigger = ({ poll }: PollOverlayTriggerProps) => {
  const { togglePollOverlay, overlayPollId } = usePollsOverlays()
  const { accent } = useWebinarColors()

  const isActive = overlayPollId === String(poll.pollId)

  return (
    <TtTooltip
      placement="top-end"
      hoist
      skidding={12}
      content={
        isActive
          ? intl.formatMessage({ defaultMessage: 'Remove from the video' })
          : intl.formatMessage({ defaultMessage: 'Display on the video' })
      }
    >
      <button
        aria-label={
          isActive
            ? intl.formatMessage({ defaultMessage: `hide poll overlay` })
            : intl.formatMessage({ defaultMessage: `show poll overlay` })
        }
        type="button"
        className="poll-overlay-trigger"
        onClick={() => togglePollOverlay(toPollOverlayPayload(poll))}
      >
        <TtIcon
          name="eye"
          style={{ color: isActive ? accent.color : 'inherit' }}
        />
      </button>
    </TtTooltip>
  )
}
